import React, { useState } from 'react';
import axios from 'axios';

function RegisterModal({ onClose }) 
{
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');

    const BASE_URL = process.env.NODE_ENV === 'production'
    ? (process.env.REACT_APP_IS_BETA === 'true' ? 'https://betaquotes.omntec.com' : 'https://quotes.omntec.com')
    : window.location.protocol === 'https:' 
        ? 'https://localhost:3001'
        : 'http://localhost:3001';


    const handleRegister = async () => {
        try {
            const response = await axios.post(`${BASE_URL}/api/register`, {
                name,
                email: email.toLowerCase(),
                phoneNumber,
                password
            });
            if (response.data.success) 
            {
                onClose();
            } 
            else 
            {
                setError('Registration failed.');
            }
        } 
        catch (err) 
        {
            setError('Something went wrong. Please try again.');
        }
    };

    // Key press handler for the Enter key
    const handleKeyPress = (e) => 
    {
        if (e.key === 'Enter') 
        {
            handleRegister();
        }
    };

    return (
        <div className="modal">
            <div className="modal-content">
                <img src="/Logo-5.png" width={600} height={200} alt="Omntec Logo" />
                <h2 style={{color: "white"}}>Register</h2>
                <input 
                    type="text" 
                    placeholder="Name" 
                    value={name} 
                    onChange={(e) => setName(e.target.value)}
                />
                <input 
                    type="email" 
                    placeholder="Email" 
                    value={email} 
                    onChange={(e) => setEmail(e.target.value.toLowerCase())} 
                />
                <input 
                    type="text" 
                    placeholder="Phone Number" 
                    value={phoneNumber} 
                    onChange={(e) => setPhoneNumber(e.target.value)} 
                />
                <input 
                    type="password" 
                    placeholder="Password" 
                    value={password} 
                    onChange={(e) => setPassword(e.target.value)}
                    onKeyPress={handleKeyPress}
                />
                {error && <p style={{ color: 'red' }}>{error}</p>}
                <button onClick={handleRegister}>Register</button>
                <button onClick={onClose}>Close</button>
            </div>
        </div>
    );
}

export default RegisterModal;
